<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_paidholiday" transform="translate(1694 2998)">
      <path
        id="패스_4038"
        data-name="패스 4038"
        fill="#21bf54"
        d="M19,15l-1.25,2.75L15,19l2.75,1.25L19,23l1.25-2.75L23,19l-2.75-1.25Z"
        transform="translate(-1694 -2998)"
      />
      <path
        id="패스_4044"
        data-name="패스 4044"
        fill="#ffc304"
        d="M19,9l1.25-2.75L23,5,20.25,3.75,19,1,17.75,3.75,15,5l2.75,1.25Z"
        transform="translate(-1694 -2998)"
      />
      <path
        id="패스_4045"
        data-name="패스 4045"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1694 -2998)"
      />
      <path
        id="패스_4046"
        data-name="패스 4046"
        fill="#087ef7"
        d="M11.5,9.5,9,4,6.5,9.5,1,12l5.5,2.5L9,20l2.5-5.5L17,12Z"
        transform="translate(-1694 -2998)"
      />
      <path
        id="패스_4047"
        data-name="패스 4047"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1694 -2998)"
      />
      <path
        id="패스_4049"
        data-name="패스 4049"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1694 -2998)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
